import React, {useState} from 'react'
import ReactDOM from 'react-dom/client'
import "./style.css"
import {RouterProvider} from "react-router-dom";
import Router from "./Router";
import {ApiProvider, LOG_LEVELS} from "./ApiSession";
import * as allApi from "./rest";


const rootElement = document.getElementById('app')

if (!rootElement) throw new Error('Failed to find the root element')


const doLogout = () => document.location.href = "/login"

ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
        <ApiProvider
            logLevel={LOG_LEVELS.SILENT}
            apiDict={allApi}
            afterLogoutFunc={doLogout}
            onSessionExpired={doLogout}
        >
            <RouterProvider router={Router}/>
        </ApiProvider>
    </React.StrictMode>
)

